// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum CollaborationVerificationResult {
  Failure = 0,
  Success = 1,
  InvalidEmailFormat = 2,
  CollaboratorNotFound = 3,
  SelfAddNotAllowed = 4,
  CountryCodeMismatch = 5,
  GocRestricted = 6,
}
